import { render, staticRenderFns } from "./GeneralInput1.vue?vue&type=template&id=7084a5d4&scoped=true"
import script from "./GeneralInput1.vue?vue&type=script&lang=js"
export * from "./GeneralInput1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084a5d4",
  null
  
)

export default component.exports